<div class="habit-card" [class.completed]="isComplete">
  <button type="button" class="habit-toggle"
          (click)="doToggle()"
          [attr.aria-pressed]="isComplete"
          [attr.aria-label]="isComplete ? 'Mark as not done today' : 'Mark as done today'">
    <span class="toggle-mark" *ngIf="isComplete">✓</span>
  </button>

  <div class="habit-body">
    <div class="habit-header">
      <span class="habit-name">{{ habit.name }}</span>
      <span *ngIf="habit.category" class="habit-tag">{{ habit.category }}</span>
      <span *ngIf="streak >= 2" class="habit-streak">🔥 {{ streak }}</span>
      <button type="button" class="habit-edit-btn" (click)="doEdit($event)" aria-label="Edit habit">✎</button>
    </div>

    <div class="habit-heatmap" *ngIf="last7Days.length">
      <span *ngFor="let day of last7Days"
            class="heatmap-cell"
            [class.filled]="day.completed"
            [attr.title]="day.date + (day.completed ? ' ✓' : '')"></span>
    </div>

    <button *ngIf="showAddNoteButton"
            type="button"
            class="add-note-btn"
            (click)="expandNote()">+ Add note</button>

    <textarea *ngIf="showNotesArea"
              class="habit-note"
              placeholder="What stood out today?"
              [value]="draftNote"
              (input)="onNoteInput($any($event.target).value)"
              (blur)="onNoteBlur()"
              rows="2"></textarea>

    <div *ngIf="isComplete" class="completed-badge">✓ Completed today</div>
  </div>
</div>
